/** @format */

import React, { PureComponent } from 'react';
import Datetime from 'react-datetime';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import Moment from 'moment';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import InputLabel from '@material-ui/core/InputLabel';
import I18n from '../Translate/I18n';

require('moment/locale/pl');

class CustomDatePicker extends PureComponent {
    componentDidMount() {
        if (!this.props.defaultValue) {
            this.props.callback(new Moment());
        }
    }

    render() {
        const {
            classes,
            defaultValue,
            isValidDate,
            callback,
            helpText,
            error,
            success,
            id,
            dateFormat,
            fieldName,
            fullWidth,
            timeFormat,
            autoComplete,
        } = this.props;

        let { placeholder } = this.props;

        const helpTextClasses = classNames({
            [classes.labelRootError]: error,
            [classes.labelRootSuccess]: success && !error,
        });

        let overrideDefaultValue;

        if (defaultValue) {
            overrideDefaultValue = defaultValue;
        } else {
            if (placeholder) {
                overrideDefaultValue = null;
            } else {
                overrideDefaultValue = new Date();
            }
        }

        if (!placeholder) {
            if (timeFormat === true) {
                placeholder = 'YYYY-MM-DD HH:MM';
            } else if (typeof timeFormat === 'string') {
                if (dateFormat) {
                    placeholder = `${dateFormat} ${timeFormat}`;
                } else {
                    placeholder = `YYYY-MM-DD ${timeFormat}`;
                }
            } else {
                placeholder = 'YYYY-MM-DD';
            }
        }

        let df = 'YYYY-MM-DD';
        if (dateFormat) {
            df = dateFormat;
        }

        if (timeFormat === true) {
            if (!df.includes('HH:mm')) {
                df = `${df} HH:mm`;
            }
        } else if (typeof timeFormat === 'string') {
            df = `${df} ${timeFormat}`;
        }
        return (
            <FormControl id={'reactDateTime'} className={classes.formControl} fullWidth={fullWidth || true}>
                {helpText !== undefined ? (
                    <InputLabel className={classes.labelRoot + ' ' + helpTextClasses} htmlFor={id}>
                        <I18n trans={helpText} asterisk={true} />
                    </InputLabel>
                ) : null}
                <Datetime
                    locale="pl"
                    {...this.props}
                    defaultValue={DateHelperTs.format(overrideDefaultValue, df ?? 'DD-MM-YYYY')}
                    value={DateHelperTs.format(overrideDefaultValue, df ?? 'DD-MM-YYYY')}
                    isValidDate={isValidDate}
                    onChange={(moment) => callback(moment)}
                    inputProps={{
                        id: fieldName,
                        placeholder: placeholder,
                        autoComplete: autoComplete,
                        className: classes.datePickerInput,
                    }}
                />
            </FormControl>
        );
    }
}

CustomDatePicker.propTypes = {
    callback: PropTypes.func.isRequired,
    helpText: PropTypes.string,
    dateFormat: PropTypes.string,
    placeholder: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isValidDate: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    error: PropTypes.bool,
    success: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fieldName: PropTypes.string,
    fullWidth: PropTypes.bool,
    autoComplete: PropTypes.string,
    timeFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    open: PropTypes.bool,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
};

export default withStyles(oplAppStyle)(CustomDatePicker);
